// extracted by mini-css-extract-plugin
export var productImage = "_qf-1";
export var viewLink = "_qf-2";
export var wishlistItem = "_qf-0";